import axios from 'axios'
import {Noti} from 'generated/JavaTOmodifications';

export const fetchCurrentNoti = () => axios.get<Noti[]>('../json/noti/current');
export const markNotiReadAPI = (id: number) => axios.put<Noti>(`../json/noti/${encodeURIComponent(id)}/read`);
export const markNotiUnreadAPI = (id: number) => axios.put<Noti>(`../json/noti/${encodeURIComponent(id)}/unread`);
export const deleteNotiAPI = (id: number) => axios.delete(`../json/noti/${encodeURIComponent(id)}`);